import React, { useState } from "react";
import QR from "./QR";

const QRCodeButton = ({ location }) => {
  const [isQROpen, setIsQROpen] = useState(false);

  return (
    <>
      <button
        onClick={() => {
          setIsQROpen(!isQROpen);
        }}
        className="px-2 py-1 text-secondaryText font-semibold bg-secondary border border-secondaryText rounded-2xl"
        style={{
          position: "absolute",
          bottom: "25%",
          left: "50%",
          translate: "-50% 0",
        }}
      >
        View on Phone
      </button>
      {isQROpen ? <QR setIsQROpen={setIsQROpen} /> : ""}
    </>
  );
};

export default QRCodeButton;
